/*eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { DistanceFilter } from './DistanceFilter';
import { GenderFilter } from './GenderFilter';
import { LanguageFilter } from './LanguageFilter';
import {
  setSearchProviderFilters,
  resetSearchProviderFilters,
  setShowAllFiltersPanel,
} from '../../../../../redux/member/priceCompareSlice';
import {
  getPriceComaperFilters,
  searchProviders,
} from '../../../../../redux/member/api-calls/priceCompare';
import { BestMatchFilter } from './BestMatchFilter';
import PrimaryButton from '../../../common/button';
import GenericButton from '../../../../../Components/GenericButton/GenericButton';
import AllFilterOptions from './AllFilterOptions';
import './SearchFilter.scss';
import { t } from 'i18next';

const SearchFilter = (props) => {
  const isFromCignaRoaster = props.isFromCignaRoaster;
  const { showAllFiltersPanel } = useSelector((state) => state.priceCompare);
  const dispatch = useDispatch();
  const allFilters = useSelector(
    ({ priceCompare }) => priceCompare.searchProviderParams.filters,
  );
  const { Gender, maximumradius, spokenlanguages } = allFilters;
  const filtersValuesList = useSelector(
    ({ priceCompare }) => priceCompare.filtersValuesList,
  );

  const onChangeHandler = async (paramName, value) => {
    if (paramName !== 'spokenlanguages') {
      dispatch(setSearchProviderFilters({ [paramName]: value }));
    }
    if (paramName === 'spokenlanguages') {
      if (value) {
        const valuesToSave = value.map((val) => {
          return val.value;
        });
        dispatch(setSearchProviderFilters({ spokenlanguages: valuesToSave }));
      } else {
        dispatch(setSearchProviderFilters({ spokenlanguages: null }));
      }
    }
  };

  const applyAllFilters = (selectedOptions) => {
    dispatch(setSearchProviderFilters(selectedOptions));
    dispatch(setShowAllFiltersPanel(false));
  };

  const resetFilters = () => {
    dispatch(resetSearchProviderFilters());
  };

  return (
    <>
      <AllFilterOptions
        isVisible={showAllFiltersPanel}
        onHide={() => {
          dispatch(setShowAllFiltersPanel(false));
        }}
        //filters={allFilters}
        onApply={applyAllFilters}
        isFromCignaRoaster={isFromCignaRoaster}
      />
    </>
  );
};

export default SearchFilter;
